import {
  getSchedulingAccess,
  getUserAccess,
} from "../../../utils/organization-helpers";
import { getUserToRequest } from "../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import Scheduling from "./Scheduling";

const schedulingController = async ({ res, req, locals }) => {
  const {
    activeUser,
    organizationOwner,
    organizationPermissions = [],
    organizationRoles = [],
  } = locals;

  const access = getUserAccess(
    activeUser,
    organizationOwner,
    organizationPermissions,
    organizationRoles
  );

  if (
    !access.userCanAccessToPress &&
    !access.userCanAccessToPerform &&
    !access.userCanAccessToPull
  ) {
    return res.redirect("/coaching-portal/athletes");
  }

  const userIsCoach = activeUser.permissions?.includes("coach");
  const userToRequest = userIsCoach
    ? getUserToRequest(activeUser, organizationOwner)
    : activeUser;

  const {
    schedulingEnabled,
    hasNonPullScheduling,
    hasPressScheduling,
    hasPullScheduling,
  } = getSchedulingAccess(userToRequest, access);
  if (!schedulingEnabled) {
    return res.redirect("/coaching-portal/athletes");
  }

  const tab = req.query?.tab || "overview";
  const preview =
    typeof req.query?.preview === "string" ? req.query.preview : undefined;
  const previewId =
    typeof req.query?.previewId === "string" ? req.query.previewId : undefined;
  res.body = (
    <Scheduling
      tab={tab}
      preview={preview}
      previewId={previewId}
      hasNonPullScheduling={hasNonPullScheduling}
      hasPressScheduling={hasPressScheduling}
      hasPullScheduling={hasPullScheduling}
      canPushUser={access.userCanAccessToPush}
      canPullUser={access.userCanAccessToPull}
    />
  );
};

export default schedulingController;
